exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Card_card--m_1tPx {\n  padding: 24px;\n}\n\n.Card_card--grey_2z-F {\n  background: #f9f9f9;\n}\n\n.Card_card--purple_1E65 {\n  background: #9378fa;\n}\n", ""]);

// exports
exports.locals = {
	"card--m": "Card_card--m_1tPx",
	"card--grey": "Card_card--grey_2z-F",
	"card--purple": "Card_card--purple_1E65"
};